export default "__VITE_ASSET__11289b9b__"